import { getQueryStringAsHash, getDecodedParamFromQuery } from "utils/url";
import { getCookie } from "/services/cookies-service";
import { CLUSTER_COOKIE, BIG_BRAIN_VISITOR_ID } from "/constants/cookies";
import { getEnrichmentEntriesForSales } from "services/sales-enrichment/sales-enrichment-service";
import { getPricingVersionForSales } from "services/pricing/pricing-model/services";
import {
  HUBSPOT_API_VISITOR,
  HUBSPOT_API_CLUSTER,
  HUBSPOT_API_FROM,
  HUBSPOT_API_SOURCE,
  HUBSPOT_API_PRIVACY_CONSENT,
  URL_PARAM_FROM,
  HUBSPOT_API_PRICING_VERSION,
  HUBSPOT_API_RECENT_CONVERSION_URL
} from "./hubspot-constants";

const HUBSPOT_FORM_URL = "https://api.hsforms.com/submissions/v3/integration/submit";

export const submitHubspotForm = async (portalId, formId, emailValue) => {
  const url = `${HUBSPOT_FORM_URL}/${portalId}/${formId}`;
  const utmParams = getUtmParams();
  const data = { fields: [{ name: "email", value: emailValue }].concat(utmParams) };

  try {
    const serverResponse = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    if (serverResponse.status !== 200) {
      throw new Error(serverResponse.statusText);
    }
    await serverResponse.json();
    return true;
  } catch (err) {
    console.log("err", err);
    return false;
  }
};

const getUtmParams = () => {
  const url = window.location;
  const queryString = getQueryStringAsHash(url);
  const utmParams = [];

  const utm_source = queryString.marketing_source || queryString.utm_source;
  if (utm_source) utmParams.push({ name: "utm_source", value: utm_source });

  const utm_campaign = queryString.marketing_campaign || queryString.utm_campaign;
  if (utm_campaign) utmParams.push({ name: "utm_campaign", value: utm_campaign });

  const utm_banner = queryString.marketing_banner || queryString.utm_banner;
  if (utm_banner) utmParams.push({ name: "utm_banner", value: utm_banner });

  const utm_content = queryString.marketing_content || queryString.utm_content;
  if (utm_content) utmParams.push({ name: "utm_content", value: utm_content });

  const utm_cluster_id = getCookie(CLUSTER_COOKIE);
  if (utm_cluster_id) utmParams.push({ name: "utm_cluster_id", value: utm_cluster_id });

  return utmParams;
};

export const getSingleUrlParamToHubspotForm = (location, urlParamName, hubspotApiName) => {
  return { name: hubspotApiName, value: getDecodedParamFromQuery(location, urlParamName) };
};

export const sendHubspotForm = async (portalId, formId, fields) => {
  if (!portalId || !formId) return;

  const HUBSPOT_ENDPOINT = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;
  const hubspotCookie = getCookie("hubspotutk");

  const request = await fetch(HUBSPOT_ENDPOINT, {
    method: "POST",
    body: JSON.stringify({
      fields,
      context: {
        hutk: hubspotCookie
      }
      // skipValidation: true
    }),
    headers: {
      "content-type": "application/json"
    }
  });

  const response = await request.json();
  return response;
};

export const generateHiddenData = ({
  withPrivacyNotice,
  source,
  overrideCampaignId,
  abTests,
  cookies,
  cloudfrontViewerCountry
}) => {
  const UTM_CAMPAIGN_PARAM_NAME = "utm_campaign";

  let urlParams = getEnrichmentEntriesForSales();
  if (overrideCampaignId) {
    const urlParamsWithoutCampaign = urlParams.filter((param) => param?.name !== UTM_CAMPAIGN_PARAM_NAME);
    urlParamsWithoutCampaign.push({ name: UTM_CAMPAIGN_PARAM_NAME, value: overrideCampaignId });
    urlParams = urlParamsWithoutCampaign;
  }

  const hiddenData = [...urlParams];

  const visitorId = getCookie(BIG_BRAIN_VISITOR_ID) || "";
  hiddenData.push({ name: HUBSPOT_API_VISITOR, value: visitorId });

  const pricingVersion =
    getPricingVersionForSales({
      cookies,
      abTests,
      countryCode: cloudfrontViewerCountry
    }) || "";
  hiddenData.push({ name: HUBSPOT_API_PRICING_VERSION, value: pricingVersion });

  const clusterId = getCookie(CLUSTER_COOKIE) || "";
  hiddenData.push({ name: HUBSPOT_API_CLUSTER, value: clusterId });

  hiddenData.push({ name: HUBSPOT_API_SOURCE, value: source });

  hiddenData.push({ name: HUBSPOT_API_PRIVACY_CONSENT, value: withPrivacyNotice });

  hiddenData.push({ name: HUBSPOT_API_RECENT_CONVERSION_URL, value: window?.location?.href });

  const fromUrlParamObject = getSingleUrlParamToHubspotForm(window.location, URL_PARAM_FROM, HUBSPOT_API_FROM);
  if (fromUrlParamObject.value) hiddenData.push(fromUrlParamObject);

  return hiddenData;
};
